import React, { useState, useEffect } from "react";
import {
  listarStatusOferta,
  adicionarStatusOferta,
  alterarStatusOferta,
  toggleStatusOferta,
} from "../../../services/http/statusOfertaService";
import { useSnackBar } from "../../../hooks/snackBar";
import "../../Configuracoes/StatusOfertaTab/styles.scss";

const StatusOfertaTab = () => {
  const { addSnackBar } = useSnackBar();

  const [statusList, setStatusList] = useState([]);
  const [loading, setLoading] = useState(true);
  const [novoStatus, setNovoStatus] = useState("");
  const [editandoId, setEditandoId] = useState(null);
  const [editandoDescricao, setEditandoDescricao] = useState("");
  const [statusEditando, setStatusEditando] = useState(null);

  // Carregar lista de status ao montar o componente
  useEffect(() => {
    carregarStatusList();
  }, []);

  const carregarStatusList = async () => {
    try {
      setLoading(true);
      const response = await listarStatusOferta();
      if (response.fail == null) {
        setStatusList(response.data || []);
      } else {
        addSnackBar({
          message: response.errors[0].menssagem || "Erro ao carregar status",
          info: "error",
          open: true,
        });
      }
    } catch (error) {
      console.error("Erro ao carregar status:", error);
      addSnackBar({
        message: "Erro ao carregar status",
        info: "error",
        open: true,
      });
    } finally {
      setLoading(false);
    }
  };

  const handleToggleStatus = async (id) => {
    try {
      const status = statusList.find((s) => s.id === id);
      const novoStatus = !status.ativo;

      const response = await toggleStatusOferta(id, novoStatus);
      if (response.fail == null) {
        setStatusList((prev) =>
          prev.map((status) =>
            status.id === id ? { ...status, ativo: novoStatus } : status
          )
        );
        addSnackBar({
          message: novoStatus ? "Status ativado com sucesso" : "Status inativado com sucesso",
          info: "success",
          open: true,
        });
      } else {
        addSnackBar({
          message: response.errors[0].menssagem || "Erro ao alterar status",
          info: "error",
          open: true,
        });
      }
    } catch (error) {
      console.error("Erro ao alterar status:", error);
      addSnackBar({
        message: "Erro ao alterar status",
        info: "error",
        open: true,
      });
    }
  };

  const handleEditar = (status) => {
    setEditandoId(status.id);
    setEditandoDescricao(status.descricao);
    setStatusEditando(status);
  };

  const handleSalvarEdicao = async () => {
    if (editandoDescricao.trim()) {
      try {
        const response = await alterarStatusOferta({
          id: editandoId,
          descricao: editandoDescricao.trim(),
          ativo: statusEditando.ativo,
          dataCriacao: statusEditando.dataCriacao,
        });

        if (response.fail == null) {
          setStatusList((prev) =>
            prev.map((status) =>
              status.id === editandoId
                ? { ...status, descricao: editandoDescricao.trim(), dataAtualizacao: new Date().toISOString() }
                : status
            )
          );
          setEditandoId(null);
          setEditandoDescricao("");
          setStatusEditando(null);
          addSnackBar({
            message: "Status atualizado com sucesso",
            info: "success",
            open: true,
          });
        } else {
          addSnackBar({
            message: response.errors[0].menssagem || "Erro ao editar status",
            info: "error",
            open: true,
          });
        }
      } catch (error) {
        console.error("Erro ao editar status:", error);
        addSnackBar({
          message: "Erro ao editar status",
          info: "error",
          open: true,
        });
      }
    }
  };

  const handleCancelarEdicao = () => {
    setEditandoId(null);
    setEditandoDescricao("");
    setStatusEditando(null);
  };

  const handleAdicionarStatus = async () => {
    if (novoStatus.trim()) {
      try {
        const response = await adicionarStatusOferta({
          descricao: novoStatus.trim(),
        });

        if (response.fail == null) {
          // Recarregar a lista para obter o novo status com ID do servidor
          await carregarStatusList();
          setNovoStatus("");
          addSnackBar({
            message: "Status adicionado com sucesso",
            info: "success",
            open: true,
          });
        } else {
          addSnackBar({
            message: response.errors[0].menssagem || "Erro ao adicionar status",
            info: "error",
            open: true,
          });
        }
      } catch (error) {
        console.error("Erro ao adicionar status:", error);
        addSnackBar({
          message: "Erro ao adicionar status",
          info: "error",
          open: true,
        });
      }
    }
  };

  if (loading) {
    return (
      <div className="status-oferta-container">
        <div className="row d-flex justify-content-center">
          <div className="col-12 text-center">
            <div className="spinner-border" role="status">
              <span className="sr-only">Carregando...</span>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="status-oferta-container">
      <div className="row mb-3">
        <div className="col-12">
          <h2 className="titulo">Status da Oferta</h2>
        </div>
      </div>

      {/* Seção de adicionar novo status */}
      <div className="row mb-4">
        <div className="col-12">
          <div className="add-status-section">
            <div className="row">
              <div className="col-md-8">
                <input
                  type="text"
                  value={novoStatus}
                  onChange={(e) => setNovoStatus(e.target.value)}
                  placeholder="Digite o novo status"
                  className="form-control"
                  onKeyPress={(e) =>
                    e.key === "Enter" && handleAdicionarStatus()
                  }
                />
              </div>
              <div className="col-md-4">
                <button
                  className="button-anexar buton-green w-100"
                  onClick={handleAdicionarStatus}
                  disabled={!novoStatus.trim()}
                >
                  ADICIONAR STATUS
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Lista de status */}
      <div className="row">
        <div className="col-12">
          <div className="status-list">
            {statusList.map((status) => (
              <div
                key={status.id}
                className={`status-item ${!status.ativo ? "inativo" : ""}`}
              >
                <div className="row align-items-center">
                  <div className="col-md-6">
                    <div className="status-field">
                      {editandoId === status.id ? (
                        <input
                          type="text"
                          value={editandoDescricao}
                          onChange={(e) => setEditandoDescricao(e.target.value)}
                          className="form-control"
                          autoFocus
                          onKeyPress={(e) =>
                            e.key === "Enter" && handleSalvarEdicao()
                          }
                        />
                      ) : (
                        <span className="status-nome">{status.descricao}</span>
                      )}
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="status-actions">
                      {editandoId === status.id ? (
                        <div className="row">
                          <div className="col-6">
                            <button
                              className="buton-green w-100"
                              onClick={handleSalvarEdicao}
                            >
                              Salvar
                            </button>
                          </div>
                          <div className="col-6">
                            <button
                              className="buton-white-black-border w-100"
                              onClick={handleCancelarEdicao}
                            >
                              Cancelar
                            </button>
                          </div>
                        </div>
                      ) : (
                        <div className="row">
                          <div className="col-6">
                            <button
                              className="buton-white-black-border w-100"
                              onClick={() => handleEditar(status)}
                            >
                              Editar
                            </button>
                          </div>
                          <div className="col-6">
                            <button
                              className={
                                status.ativo
                                  ? "buton-red w-100"
                                  : "buton-green w-100"
                              }
                              onClick={() => handleToggleStatus(status.id)}
                            >
                              {status.ativo ? "Inativar" : "Ativar"}
                            </button>
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default StatusOfertaTab;

